import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals, FctValue } from '../../../../Fct/generics';
import { FaTimes, FaDivide } from 'react-icons/fa';
import { supportedContracts } from '../constants';
export var MultiplyAndDivide = createPlugin({
    protocol: 'TOKEN_MATH',
    type: 'CALCULATOR',
    method: 'mulAndDiv',
    description: 'Multiply amount1 by amount2 and divide by amount3',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                numerator: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaTimes }),
                decimals1: new FctDecimals({}),
                factor: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaDivide }),
                decimals2: new FctDecimals({}),
                denominator: new FctValue({ destination: 'wei_amount', isPreview: true }),
                decimals3: new FctDecimals({}),
                decimalsOut: new FctDecimals({}),
            },
        },
        output: {
            result: new FctValue({
                innerIndex: 0,
            }),
        },
    }); },
});
